import React, { useEffect, useState } from "react";
import { Form, Select } from "antd";
import {
  categoryListAction,
  selectedCategoryList,
} from "../../../actions/admin";
import { useDispatch } from "react-redux";

// Define interface for pagination params
interface PaginationParams {
  page?: number;
  limit?: number;
}

interface ListingInitialData {
  dataToSet?: any;
  onSelect?: (userId: any) => void;
  setSelectedCatId?: number;
}

const { Option } = Select;

const CategoryListing: React.FC<ListingInitialData> = ({
  dataToSet,
  onSelect,
}) => {
  const [data, setData] = useState<any[]>([]);
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState<boolean>(true);
  const [categoryData, setCategoryData] = useState<any[]>([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 7,
    total: 0,
    totalPages: 0,
  });

  // Load initial data
  useEffect(() => {
    fetchCategoryList({
      page: 1,
      limit: pagination.pageSize,
    });
  }, []);

  // Load selected category when dataToSet changes
  useEffect(() => {
    if (dataToSet?.id && dataToSet?.categoryId) {
      getSelectedCategory(dataToSet?.categoryId);
    }
  }, [dataToSet?.id, dataToSet?.categoryId]);

  // Helper function to merge and deduplicate data
  const mergeAndDeduplicate = (existingData: any[], newData: any[]) => {
    const combinedData = [...existingData, ...newData];
    return combinedData.filter(
      (value, index, self) =>
        index === self.findIndex((item) => item.id === value.id)
    );
  };

  // Callback handler for selected category response
  const handleSelectedCategoryResponse = (resp: any) => {
    setLoading(false);
    setCategoryData(resp?.category);
    setData((prevData) => mergeAndDeduplicate(prevData, [resp?.category]));
  };

  // Function to get selected category
  const getSelectedCategory = (id: any) => {
    setLoading(true);
    dispatch(selectedCategoryList(id, handleSelectedCategoryResponse));
  };

  // Callback handler for category list response
  const handleCategoryListResponse = (resp: any) => {
    setLoading(false);
    if (resp?.status === 200) {
      setData((prevData) => mergeAndDeduplicate(prevData, resp.data || []));

      setPagination({
        ...pagination,
        total: resp.pagination?.totalItems,
        current: resp.pagination?.currentPage,
        pageSize: resp.pagination?.pageSize,
        totalPages: resp.pagination?.totalPages,
      });
    }
  };

  // Fetches the list of categories with optional query parameters
  const fetchCategoryList = (params: PaginationParams = {}) => {
    setLoading(true);
    dispatch(categoryListAction(params, handleCategoryListResponse));
  };

  // Handle onPopupScroll event for the Select component
  const handleSelectScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { target } = e;
    if (
      !loading &&
      target instanceof HTMLElement &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight - 20 &&
      pagination.current < pagination.totalPages
    ) {
      // Load next page
      const nextPage = pagination.current + 1;
      fetchCategoryList({
        page: nextPage,
        limit: pagination.pageSize,
      });
    }
  };

  return (
    <div className="mb-[20px]">
      <Form.Item
        name="categoryId"
        rules={[{ required: true, message: "Please select a Category" }]}
      >
        <Select
          placeholder="Category Name"
          className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto"
          onPopupScroll={handleSelectScroll}
          loading={loading}
          notFoundContent={loading ? "Loading..." : "No data found"}
          listHeight={200}
          onChange={(value) => {
            if (onSelect) {
              onSelect(value);
            }
          }}
          allowClear
          // showSearch
        >
          {data?.map((cat) => (
            <Option
              key={cat.id}
              value={cat.id}
              style={{
                backgroundColor: "#013351",
                border: "none",
              }}
            >
              <div
                style={{ display: "flex", flexDirection: "row", gap: "2px" }}
              >
                {cat.name}&nbsp;({cat.description})
              </div>
            </Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
};

export default CategoryListing;
